'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 2rem;\n  z-index: 10;\n  background-color: #333;\n  color: white;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 2rem;\n  z-index: 10;\n  background-color: #333;\n  color: white;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: 100%;\n  width: 33%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  img {\n    height: 90%;\n    margin-right: 0.5rem;\n  }\n  @media(max-width: 450) {\n    span {display: hidden}\n  }\n'], ['\n  height: 100%;\n  width: 33%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  img {\n    height: 90%;\n    margin-right: 0.5rem;\n  }\n  @media(max-width: 450) {\n    span {display: hidden}\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 33%;\n  text-align: center;\n  color: white;\n'], ['\n  width: 33%;\n  text-align: center;\n  color: white;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: white;\n  @media (max-width: 750px) {\n    display: none;\n  }\n'], ['\n  color: white;\n  @media (max-width: 750px) {\n    display: none;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 33%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  margin-right: 0.5rem;\n\n  button {\n    box-sizing: border-box;\n    height: 1.5rem;\n    color: white;\n    background-color: transparent;\n    border: 1px solid white;\n    border-radius: 2px;\n    margin: 2px;\n    text-align: center;\n    cursor: pointer;\n    &:hover {\n      background-color: white;\n      color: #333;\n    }\n    @media(max-width: 450) {\n      span {display: none;}\n    }\n  }\n'], ['\n  width: 33%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  margin-right: 0.5rem;\n\n  button {\n    box-sizing: border-box;\n    height: 1.5rem;\n    color: white;\n    background-color: transparent;\n    border: 1px solid white;\n    border-radius: 2px;\n    margin: 2px;\n    text-align: center;\n    cursor: pointer;\n    &:hover {\n      background-color: white;\n      color: #333;\n    }\n    @media(max-width: 450) {\n      span {display: none;}\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _tooltip = require('../tooltip/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _volume = require('../volume/volume');

var _volume2 = _interopRequireDefault(_volume);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NavBar = _styledComponents2.default.header(_templateObject);

var Brand = _styledComponents2.default.div(_templateObject2);

var Title = _styledComponents2.default.div(_templateObject3);

var ExpoName = _styledComponents2.default.div(_templateObject4);

var Controls = _styledComponents2.default.div(_templateObject5);

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        NavBar,
        null,
        _react2.default.createElement(
          Brand,
          null,
          _react2.default.createElement('img', { src: this.props.icon }),
          _react2.default.createElement(
            ExpoName,
            null,
            this.props.name
          )
        ),
        _react2.default.createElement(
          Title,
          null,
          this.props.location
        ),
        _react2.default.createElement(
          Controls,
          null,
          _react2.default.createElement(
            _tooltip2.default,
            { text: 'Adjust Volume', orientation: 'left' },
            _react2.default.createElement(
              'button',
              { onClick: function onClick() {
                  if (window.vexpo && window.vexpo.sound) window.vexpo.sound.showVolume();
                } },
              _react2.default.createElement(_reactFontawesome2.default, { name: 'volume-up' })
            )
          ),
          _react2.default.createElement(
            _tooltip2.default,
            { text: 'Show Locations', orientation: 'left' },
            _react2.default.createElement(
              'button',
              { onClick: function onClick() {
                  return window.vexpo.showLocations();
                } },
              _react2.default.createElement(_reactFontawesome2.default, { name: 'map-signs' })
            )
          )
        )
      );
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/navigation/header.js
// module id = 1070
// module chunks = 0